// extracted by css-extract-rspack-plugin
export default {"root":"OptionItem_root__IcvG7","icon":"OptionItem_icon__ONobm"};